export enum ButtonType {
  topMenu,
  imageToolbar,
  blockToolbar,
  editableTextToolbar,
  blockTemplateEditorToolbar,
}
export interface ExternalToolbarButton {
  getToolbarButtonData: (element: HTMLElement) => Button;
}
export interface Button {
  id: string;
  title: string | Function;
  icon: string;
  onClick: Function;
  extraClass?: string;
  type?: ButtonType;
  attributes?: Object;
  state?: Function;
}
export type ButtonTitleGetter = (button: Button, params?: any) => string;
export interface RegisteredButton extends Button {
  id: string;
  state: Function;
}
export interface Buttons {
  getById: (id: string) => RegisteredButton;
  getByType: (type: ButtonType) => RegisteredButton[];
  register(button: Button): string;
}
